export default {"src":"/_next/static/media/faq-icon5.d39abc33.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};